import template from './form.html';
import { FormActions } from 'core/services/excepcion-form';
import disponibilidadesI18N from 'i18n/disponibilidades/es.json';
import commonI18N from 'i18n/common/es.json';
import { pad } from 'core/util';


export let ExcepcionFormComponent = {
  templateUrl: template,
  selector: 'excepcionForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(disponibilidadesI18N).concat(Object.keys(commonI18N));


FormController.$inject = [
  '$state', '$ngRedux', 'ngNotify', '$stateParams', 'Filter', 'BasicFactory', '$timeout', '$scope',
  '$rootScope', '$transitions'
];

function FormController($state, $ngRedux, ngNotify, $stateParams, Filter, BasicFactory, $timeout,
  $scope, $rootScope, $transitions) {
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.doSubmit = doSubmit.bind(this);
  this.doCancel = doCancel.bind(this);
  this.flags = {};
  let unsubscribe;

  this.sliderOptionsFull = {
    floor: 0,
    ceil: 24,
    step: 1,
    minRange: 0,
    maxRange: 24,
    noSwitching: true,
    translate(value) {
      return `${~~value}:${'00'}`;
    }
  };

  this.sliderOptions = [{
    floor: 0,
    ceil: 24,
    step: 1,
    minRange: 0,
    maxRange: 24,
    noSwitching: true,
    showTicks: true,
    translate(value) {
      return `${pad(~~(value/2), 2)}:${value%2 ? '30' : '00'}`;
    }
  }, {
    floor: 24,
    ceil: 36,
    step: 1,
    minRange: 0,
    maxRange: 12,
    noSwitching: true,
    showTicks: true,
    translate(value) {
      return `${pad(~~(value/2), 2)}:${value%2 ? '30' : '00'}`;
    }
  }, {
    floor: 36,
    ceil: 48,
    step: 1,
    minRange: 0,
    maxRange: 12,
    noSwitching: true,
    showTicks: true,
    translate(value) {
      return `${pad(~~(value/2), 2)}:${value%2 ? '30' : '00'}`;
    }
  }];



  this.localModel = {
    fechaOptions: {
      minDate: new Date()
    },
    hastaOptions: {},
    desdeOptions: { minDate: new Date() }
  };

  this.onChangeDate = onChangeDate.bind(this);

  function onChangeDate() {
    if (this.model && this.model.fecha) {
      this.localModel.desdeOptions.maxDate = this.model.fechaFin;
      this.localModel.hastaOptions.minDate = this.model.fecha;
    }
  }

  this.localModel.horarios = [
    {
      inicio: 16,
      fin: 24
    }, {
      inicio: 24,
      fin: 36
    }, {
      inicio: 36,
      fin: 40
    }
  ];


  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.loading = true;

  this.$onInit = () => {

    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);
    this.props = { save: this.save };
    this.listState = this.view ? 'home.disponibilidades.uid.view' : 'home.disponibilidades.uid.edit';

    if ($stateParams.eid) {
      this.title = this.view ? this.translations['Ver excepción'] : this.translations['Editar excepción'];
      this.formEdit('excepciones-disponibilidades', $stateParams.eid);
      this.isEdit = true;
    } else {
      this.title = this.translations['Nueva excepción'];
      this.form();
    }

  };


  this.$postLink = () => {
    let self = this;
    $timeout(function() {
      $scope.$broadcast('init');
      self.loading = false;
      //$scope.$broadcast('rzSliderForceRender');
    });
  };


  function mapStateToThis(state) {
    this.handleStatus(state);
    this.submitted = state.excepcionForm.flags ? state.excepcionForm.flags.submitted : false;
    this.model = state.excepcionForm.model;

    if (state.excepcionForm.model && state.excepcionForm.model.id &&
      !this.modelInit) {
      this.modelInit = true;
      this.localModel.horarios = this.model.horarios;
    } else if (state.excepcionForm.model && !state.excepcionForm.model.id) {
      this.model.habilitado = false;
    }

    if (this.model.id) {
      this.onChangeDate();
      let rangos = null;
      Object.keys(this.model.horarios).forEach(key => {
        if (rangos !== null) rangos = rangos + '\n' + key.substring(0, 16);
        else rangos = key.substring(0, 16);
      });
      this.localModel.rangos = rangos;
    }

    return { form: state.excepcionForm };
  }

  /**
   * Función que se encarga de mostrar mensajes de error/exito en base al estado actual
   * 
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.excepcionForm.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.disponibilidades.uid.edit'));
      return;
    }

    if (state.excepcionForm.error) {
      ngNotify.set(state.excepcionForm.error.message, 'error');
    }

    if (state.excepcionForm.created) {
      ngNotify.set(this.translations['Datos guardados correctamente'], 'success');
      $state.go('home.disponibilidades.uid.edit').then(() => {
        $rootScope.$broadcast('disponibilidades.reloadDatatable');
      });
    }
  }

  function doSubmit() {
    let data = Object.assign({}, this.model);
    data.horarios = this.localModel.horarios;
    data.disponibilidad = { id: parseInt($stateParams.uid) };
    data.rangoHorario = false;
    this.save('excepciones-disponibilidades', data);
  }

  function doCancel() {
    if ($state.is('home.disponibilidades.uid.view.excepciones.eid.view')) {
      $state.go('home.disponibilidades.uid.view');
    } else {
      $state.go('home.disponibilidades.uid.edit');
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/disponibilidades/excepcion-form/form.component.js